import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { User } from '../_models/user';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;
  private baseUrl = environment.apiUrl;
  private ssoUrl = environment.ssoUrl;
  logintime: any;

  constructor(private http: HttpClient, private router: Router) {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }
  login(username, password, otp, logintime) {
    localStorage.setItem('logintime', logintime);
    return this.http.post<any>(`${this.baseUrl}api/login`, {
      userName: username,
      password: password,
      otp: otp,
      event: "Login",
      // role: "Admin",
      // ObjId: "5fe041bc9fd981138cae8ec2",
      channel: "",
      loginTime: logintime,
      logoutTime: "",
      networkDetails: {
        ip: "111111111",
        city: 'hyd',
        region: 'hyd',
        country: 'ind',
        loc: '500005',
        org: 'airtel',
        postal: '506006',
        timezone: 'kolkata'
      }
    })
      .pipe(map(user => {
        // console.log(user, 'user at service')
        sessionStorage.setItem('ref', "1");
        localStorage.setItem('currentUser', JSON.stringify(user));
        this.currentUserSubject.next(user);
        return user;
      }),
        catchError(errorRes => {
          let errormessage = 'An error Occured';
          if (!errorRes.error || !errorRes.error.message) {

            return throwError(errormessage)
          }
          switch (errorRes.error.message) {
            case 'Incorrect Username or password':
              errormessage = "Incorrect Username or password";
            case 'OTP hasn\'t generated for this user.':
              errormessage = "Incorrect Otp Please Enter Again"
          }
          return throwError(errormessage)
        })
      )
  }

  getUserData() {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    return this.currentUserSubject.asObservable();
  }

  getlogintime() {
    this.logintime = localStorage.getItem('logintime');
    return this.logintime;
  }

  getClientname() {
    let client = localStorage.getItem('clientIDE');
    if(client=="Jaguar"){
      // client="Royal Enfield RSA"
    }
    return client;
  }

  sendOtp(username, password): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}api/getOtp`, { username: username, password: password, appName: "Client Portal" })
      .pipe(map(res => {
        return res
      }),
        catchError(errorRes => {
          let errormessage = 'An error Occured';
          if (!errorRes.error || !errorRes.error.message) {

            return throwError(errormessage)
          }
          switch (errorRes.error.message) {
            case 'Incorrect Username or password':
              errormessage = "Incorrect Username or password";
          }
          return throwError(errormessage)
        })
      );

  }

  logout() {
    localStorage.clear();
    sessionStorage.clear();
    this.currentUserSubject.next(null);
    this.router.navigate(['/login']);
    // window.location.href = "/login";
  }

  logouttotal(role, objId, logouttime, username) {
    console.log("came to logout")
  //  return this.http.post<any>(`${this.baseUrl}api/logout`, {
   //   role: role,
  //    event: "Logout",
  //    ObjId: objId,
  //    logoutTime: logouttime,
  //    username: localStorage.getItem('userName')+localStorage.getItem('firstName')
  //  }).subscribe(res => {
      localStorage.clear();
      sessionStorage.clear();
      this.currentUserSubject.next(null);
      window.location.replace(`https://entrusteai.in`)
      this.router.navigate(['/login']);
     //  window.location.href = "/login";
   // })
  }
  getusercontroldata(username, appname) {
    return this.http.post<any>(`${this.baseUrl}api/getUserProhibitionData`, { username: username, appName: appname })
      .pipe(map(user => {
        localStorage.setItem("controldata",JSON.stringify(user))
        return user;
      })
      )
  }

  checkSSOSession(data) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
       'Authorization': localStorage.getItem('token')
    });
    return this.http.post(`${this.ssoUrl}/api/auth/oauth2/validateToken`, data, { headers: headers }).pipe(map(data=>{
      return data;
    }))
  }
  getServerKey(data) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
       'Authorization': localStorage.getItem('token')
    });
    return this.http.post(`${this.ssoUrl}/api/auth/getServerKey`, data, { headers: headers }).pipe(map(data=>{
      let user: any
      user = {
        "success": true,
        "data": {
            "email": "hari.datla12345@gmail.com",
            // "token": "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6InJhanVkYXRsYSIsInVzZXJfaWQiOiI2NDc5OTBlMDJlZGFmOWJhZWFhZDY5MTEiLCJpYXQiOjE2OTU2MTIwMTcsImV4cCI6MTY5NTY5ODQxN30.u8AwoP7Dy9tu_pu4pAdIWb2nNnJRPsvJeEn1pENbfpI",
            "username": "rajudatla",
            "status": "Active",
            "role": "ClientRM",
            "application": "Client Portal"
        },
        "message": "6510fc736009d22ed6ee6478"
      }
      sessionStorage.setItem('ref', "1");
      localStorage.setItem('currentUser', JSON.stringify(user));
      localStorage.setItem('loginType', "SSO");
      this.currentUserSubject.next(user);
      return data;
    }))
  }
  getPermissions(roleName, applicationName, clientName) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
       'Authorization': localStorage.getItem('token')
    });
    return this.http.get(`${this.ssoUrl}/api/application/pagesOfRole?roleName=${roleName}&applicationName=${applicationName}&clientName=${clientName}`, { headers: headers }).pipe(map(data=>{
      return data;
    }))
  }

  resetPassword(username, appname, oldpwd, newpwd, role, ObjId, logintime, logouttime) {
    return this.http.post<any>(`${this.baseUrl}api/changePassword`, {
      username: username,
      application: appname,
      OldPassword: oldpwd,
      newPassword: newpwd,
      event: "changePassword",
      loginTime: logintime,
      logoutTime: logouttime,
      role: role,
      ObjId: ObjId,
      channel: "",
      networkDetails: {
        ip: "111111111",
        city: 'hyd',
        region: 'hyd',
        country: 'ind',
        loc: '500005',
        org: 'airtel',
        postal: '506006',
        timezone: 'kolkata'
      }
    })
      .pipe(map(data => {
        return data;
      }),
        catchError(errorRes => {
          // console.log(errorRes)
          let errormessage = 'An error Occured';
          if (!errorRes.error || !errorRes.error.message) {

            return throwError(errormessage)
          }
          switch (errorRes.error.message) {
            case 'Incorrect Username or password':
              errormessage = "Please enter old password correctly";
          }
          return throwError(errormessage)
        })
      )
  }

  getIpAddress() {
    return this.http
      .get('https://api.ipify.org/?format=json')
      .pipe(
        catchError(this.handleError)
      );
  }

  getGEOLocation() {

    //let headers = new HttpHeaders();
    let url = "https://api.ipgeolocation.io/ipgeo?apiKey=0f4e06b0721a4a2b82bce38abc80b31a&ip=";
    return this.http
      .get(url)
      .pipe(
        catchError(this.handleError)
      );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      'error please try again later.');
  }
}
